import { FunctionComponent } from "react";

const SessionRestored: FunctionComponent = () => {
	return <></>;
}

export default SessionRestored;